import { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';

import { FeatureMaturityLevel, ProductFeature, UserRole } from '@localstack/types';

import { MembershipService, OrganizationsService, useApiEffect, useApiGetter } from '@localstack/services';

import { useAuthProvider } from '~/hooks/useAuthProvider';
import { ContainedCustomerLayout } from '~/layouts';
import { AppRoute } from '~/config';

import { IdentityLogContent } from './IdentityLogContent';

export const IdentityLogs = (): ReactElement => {
  const { userInfo, hasFeature } = useAuthProvider();
  const isWorkspaceAdmin = userInfo?.roles.includes(UserRole.ADMIN);
  const { listIdentityEvents } = useApiEffect(OrganizationsService, ['listIdentityEvents']);

  const { data: primaryMembership, isLoading } = useApiGetter(MembershipService, 'getPrimaryMembership', []);

  if (
    (!isLoading && !primaryMembership?.org_id) ||
    !isWorkspaceAdmin ||
    !(hasFeature(ProductFeature.FEATURE_SSO) || hasFeature(ProductFeature.FEATURE_SCIM))
  ) {
    return <Navigate replace to={AppRoute.NOT_FOUND} />;
  }

  return (
    <ContainedCustomerLayout title="Identity Logs" maxWidth="lg" maturityLevel={FeatureMaturityLevel.PREVIEW}>
      <IdentityLogContent orgId={primaryMembership?.org_id} fetchFn={listIdentityEvents} />
    </ContainedCustomerLayout>
  );
};
